import axios, { AxiosResponse } from 'axios';

export interface RefreshTokenDto {
  accessToken: string;
  refreshToken: string;
}

export interface RefreshTokenResponse {
  accessToken: string;
  refreshToken: string;
}

const bareClient = axios.create({
  baseURL: process.env.REACT_APP_AUTH_SERVICE_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export const refreshTokens = async (refreshTokenDto: RefreshTokenDto) => {
  const response = await bareClient.post<
    any,
    AxiosResponse<{
      data: RefreshTokenDto;
    }>
  >('/api/v2/auth/token/refresh', refreshTokenDto, {
    baseURL: process.env.REACT_APP_AUTH_SERVICE_ENDPOINT,
  });

  return response.data;
};
